import React, { useEffect, useState } from "react";
import { Box, DarkMode } from "@chakra-ui/react";
import {
  Avatar,
  Badge,
  Button,
  Flex,
  Select,
  Td,
  Text,
  Tr,
  Icon,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  FormControl,
  FormLabel,
  Checkbox,
  Input,
} from "@chakra-ui/react";

import GradientBorder from "components/GradientBorder/GradientBorder";
import { useLoader } from 'components/Loader/loader';
import useApiReq from 'variables/apireq';

function GroupModal({ isOpen, setOpen, setGroups }) {
  const titleColor = useColorModeValue("gray.700", "gray.200");
  const {setIsLoading,isLoading} = useLoader();
  const [group_name, setGroupName] = useState("");
  const submit = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        url: "group/add/",
        method: "POST",
        data: { group_name },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.response ) {
        setGroups((prev) => {
          return [...prev, res.response];
        });
        setGroupName("");
        setOpen();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <div></div>;
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={setOpen}
      blockScrollOnMount={false}
      size='4xl'
      isCentered
      scrollBehavior='inside'
    >
      <ModalOverlay />
      <ModalContent
        p='20px'
        bg={{
          base: "rgba(19,21,56,.5)",
        }}
      >
        <ModalHeader>
          {" "}
          <Text fontSize='lg' color='#fff' fontWeight='bold'>
            Group Add
          </Text>
        </ModalHeader>
        <ModalCloseButton color='#fff' />
        <ModalBody>
          {/* Form */}

          <Flex direction='column'>
            <Box mb='0'>
              <GradientBorder
                p='2px'
                w='100%'
                me={{ base: "none", lg: "30px", xl: "none" }}
                background='transparent'
                boxShadow='0px 0px 2px 2px rgba(255,255,255,0.1)'
                borderRadius='30px'
              >
                <Flex
                  background='transparent'
                  borderRadius='30px'
                  direction='column'
                  p='40px'
                  minW={{ base: "unset" }}
                  w='100%'
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,1)",
                  }}
                >
                  <FormControl>
                    <FormLabel
                      color={"white"}
                      ms='4px'
                      mb='8px'
                      fontSize='sm'
                      fontWeight='normal'
                    >
                      Group Name
                    </FormLabel>
                    <GradientBorder
                      mb='24px'
                      h='50px'
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius='20px'
                    >
                      <Input
                        color={"white"}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border='transparent'
                        borderRadius='20px'
                        fontSize='sm'
                        size='lg'
                        w={{ base: "100%", lg: "100%" }}
                        maxW='100%'
                        h='46px'
                        type='text'
                        placeholder='Group Name'
                        value={group_name}
                        onChange={(e) => setGroupName(e.target.value)}
                      />
                    </GradientBorder>
                  </FormControl>
                </Flex>
              </GradientBorder>
            </Box>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' mr={3} onClick={submit}>
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default GroupModal;
